<template>
  <v-card :flat="flat">
    <v-card-title class="text-subtitle-1">
      {{ $t('personnePhysique.detail.form.contact.instances.title') }}
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search.nomInstance"
        :label="
          $t(
            'personnePhysique.detail.form.contact.instances.search.nomInstance',
          )
        "
        single-line
        hide-details
        clearable
        append-icon="search"
      ></v-text-field>
    </v-card-title>
    <slot />
    <v-card-text>
      <v-data-table
        :sortBy="['nom', 'prenoms']"
        :search="search.nomInstance"
        :headers="headersInstances"
        :items="instances"
        dense
      >
        <template #item.nomInstance="{item}">
          <navigable-link :to="$liens().instance(item.idInstance)">
            {{ item.nomInstance }}
          </navigable-link>
        </template>
        <template #item.typeInstance="{item}">
          {{ item.typeInstance }}
        </template>
        <template #item.typeParticipant="{item}">
          {{ item.typeParticipant }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    instances: {
      type: Array,
    },
    flat: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: {
        nomInstance: null,
      },
      headersInstances: [
        {
          text: this.$t(
            'personnePhysique.detail.form.contact.instances.headers.nomInstance',
          ),
          sortable: true,
          value: 'nomInstance',
        },
        {
          text: this.$t(
            'personnePhysique.detail.form.contact.instances.headers.typeInstance',
          ),
          sortable: true,
          value: 'typeInstance',
        },
        {
          text: this.$t(
            'personnePhysique.detail.form.contact.instances.headers.typeParticipant',
          ),
          sortable: true,
          value: 'typeParticipant',
        },
      ],
    };
  },
};
</script>
